import { db } from './firebase';
import firebase from 'firebase/app';
import * as states from '../constants/states';
import {auth} from '../firebase';

// User API

export const doCreateUser = (id, username, alias, isModerator, company, telephone) =>{
  let dateCreated = firebase.database.ServerValue.TIMESTAMP;
  let dateEdited = dateCreated;
  let claims = {
    isAdmin:false,
    isModerator:isModerator
  }

  return db.ref(`users/${id}`).set({
    username,
    alias,
    'customClaims': claims,
    'showClosedComplains': true,
    company,
    telephone,
    dateCreated,
    dateEdited
  });
}

export const doUpdateUser = (id, alias, company, telephone, isModerator) => {
  let dateEdited = firebase.database.ServerValue.TIMESTAMP;
  let claims = {
    isAdmin:false,
    isModerator:isModerator
  }

  return db.ref('users/'+id).update({
    company: company,
    telephone:telephone,
    alias: alias,
    customClaims: claims,
    dateEdited: dateEdited 
  })
}

export const doUpdateUserName = (id, username) => {
  let dateEdited = firebase.database.ServerValue.TIMESTAMP;

  return db.ref('users/'+id).update({
    dateEdited:dateEdited,
    username: username
  })
}

export const onceGetUsers = () =>
  db.ref('users').once('value');


export const onceGetUser = (id) =>
  db.ref('users/'+id).once('value'); 

export const doCreateComplain = (userId, subject, complainText) =>{
  return onceGetUser(userId)
  .then((user) => {

    let dateCreated = firebase.database.ServerValue.TIMESTAMP;
    let dateEdited = dateCreated;
    let comment = '';
    let state = states.ComplainRegistred;
    let company = user.val().company;
  
    db.ref('complains').push().set({
      userId,
      subject,
      complainText,
      comment,
      state,
      company,
      dateCreated,
      dateEdited
    });
  }); 
}

export const onceGetUsersToImpersonate = (userId) =>{
  return auth.getCurrentUserToken().then(token => {
    if(token.claims.isAdmin){
      return db.ref('users').once('value');
    }
    else if(token.claims.isModerator){
      return onceGetUser(userId).then(user => {
        return db.ref('users').orderByChild("company").equalTo(user.val().company).once("value");
      })
    }
    else{
      return;
    }
  })
}

export const updateUsershowClosedComplainsSetting = (userId ,showClosedComplains) =>
  db.ref('users/'+userId).update({
     showClosedComplains:showClosedComplains
    });

export const updateComplainComment = (complainId, comment) =>{
  let dateEdited = firebase.database.ServerValue.TIMESTAMP;

  return db.ref("complains/" + complainId).update({
    comment:comment,
    dateEdited:dateEdited
  });
}
  
export const updateComplainState = (complainId, state) => {
  //refactor check state
  let dateEdited = firebase.database.ServerValue.TIMESTAMP;

  return db.ref("complains/" + complainId).update({
    state:state,
    dateEdited:dateEdited
  })  
}




// WEBPACK FOOTER //
// ./src/firebase/db.js